import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import { Modal, Button, DialogActions, DialogTitle, DialogContent } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const ModalConfirm = (props) => {
    const classes = useStyles();
    const handleClose = () => {
        props.setOpen(false);
    }
    const handleOke = () => {
        props.setOpen(false);
        props.oke()
    }
    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={props.open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
            timeout: 500,
            }} 
        >
            <Fade in={props.open}>
            <div className={`${classes.paper} bgModal`}>
                <DialogTitle className="colorWhite">Portal {process.env.REACT_APP_COMPANY} says</DialogTitle>
                <DialogContent className="colorWhite">
                    <span dangerouslySetInnerHTML={{ __html: props.text }}></span>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOke} color="primary" autoFocus>Oke</Button>
                    <Button onClick={handleClose} color="primary" autoFocus>Batal</Button>
                </DialogActions>
            </div>
            </Fade>
            
        </Modal>
    )
}
export default ModalConfirm;

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        width: 400,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));
